<template>
	<div class="verification-wrapper">
		<div class="input-wrapper">
			<el-input v-model="userInput" placeholder="请输入验证码" />
		</div>
		<div class="pic-wrapper">
			<div id="v-container" ref="vContainer" :style="{ width: '200px', height: '50px'}"></div>
		</div>
		
	</div>
</template>

<script>
import { GVerify } from "@/services/gVerify.js";
import '@/styles/VerificationCode.css'

export default {
	data() {
		return {
			userInput: '',
			verifyCode: null
		}
	},
	mounted() {
		this.verifyCode = new GVerify(this.$refs.vContainer);
	},
	methods: {
		validateCode() {
			return this.verifyCode.validate(this.userInput); // 直接返回验证结果
		}
	}
}
</script>

<style scoped>
.verification-wrapper {
	width: 100%;
	height: 100%;
	display: flex;
	flex-wrap: wrap;
}

.input-wrapper{
	width: 100%;
}

.pic-wrapper{
	margin-top: 10px;
	margin-bottom: 10px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}


</style>
